import type { StatusChipProps } from '@/components/chip/ChipBusinessTripFormStatus';
import ChipBusinessTripFormStatus from '@/components/chip/ChipBusinessTripFormStatus';
import { StatusBusinessTripFormEnum } from '@/types/enums/business-trip-form-status.enum';

export const getBusinessTripFormStatusData = (props: StatusChipProps) => {
    return ChipBusinessTripFormStatus(props);
};

export const getBusinessTripFormOptionsFilter = (
    isFilter?: boolean,
    theme?: any
) => {
    const enumValues = StatusBusinessTripFormEnum;

    const options: any[] = [];

    Object.keys(enumValues).forEach(key => {
        const data = getBusinessTripFormStatusData({
            status: enumValues[key],
            showChip: false,
            theme,
        });

        options.push({
            id: enumValues[key],
            value: !isFilter ? enumValues[key] : key.toUpperCase(),
            title: data.label,
            label: data.label,
            color: data.colorHex,
        });
    });

    return options;
};
